<template>
  <div class="modal-wrapper cvLRVf dTIQsR">
    <!--  @click="handleBackdropClick" -->
    <div class="modal-backdrop fade in"></div>
    <div class="modal">
      <div class="modal-dialog">
        <div class="modal-content" @click.stop>
          <section class="jENZOg">
            <div></div>
            <div>
              <h1>Sign up</h1>
            </div>
            <div>
              <div class="close-button">
                <a @click.stop="$emit('close')">
                  <svg class="hGsgfJ bnCywO" viewBox="0 0 32 32">
                    <path d="m6 6 20 20"></path>
                    <path d="m26 6-20 20"></path>
                  </svg>
                </a>
              </div>
            </div>
          </section>
          <div class="sc-cpmKsF kkluyX">
            <h2>Join now and get access to our huge catalog of amazing deals!</h2>
            <p style="margin-bottom: 20px;">
              Looking to sell on Koio deal?
              <a href="http://qden2.jxdinfen.com/#/" target="_blank">Sign up for a seller account</a>
            </p>
            <!-- <div class="btns-wrapper">
              <a class="btn sc-bYTsla epuDjx" href="">
                <img src="@/assets/images/facebook.svg" style="width: 38.4px;">
                <span>Sign up with your Facebook account</span>
                <div></div>
              </a>
            </div> -->
            <div class="fancy"><span>or</span></div>
            <form class="inputs-wrapper" @submit.prevent="handleSignup">
              <div class="input-wrapper" :class="{ 'has-error': firstNameError }">
                <div class="form-group">
                  <div class="">
                    <input 
                      type="text" 
                      placeholder="First name" 
                      v-model="firstName"
                      @blur="validateFirstName"
                      @input="clearFirstNameError"
                      class="form-control"
                      style="font-size: 18px;"
                    >
                  </div>
                </div>
                <div class="input-dot" v-if="firstNameError"></div>
                <div class="input-msg" v-if="firstNameError">The first name is required.</div>
              </div>
              <div class="input-wrapper" :class="{ 'has-error': lastNameError }">
                <div class="form-group">
                  <div class="">
                    <input 
                      type="text" 
                      placeholder="Last name" 
                      v-model="lastName"
                      @blur="validateLastName"
                      @input="clearLastNameError"
                      class="form-control"
                      style="font-size: 18px;"
                    >
                  </div>
                </div>
                <div class="input-dot" v-if="lastNameError"></div>
                <div class="input-msg" v-if="lastNameError">The last name is required.</div>
              </div>
              <div class="input-wrapper" :class="{ 'has-error': emailError }">
                <div class="form-group">
                  <div class="">
                    <input 
                      type="email" 
                      placeholder="Email" 
                      v-model="email"
                      @blur="validateEmail"
                      @input="clearEmailError"
                      class="form-control"
                      style="font-size: 18px;"
                    >
                  </div>
                </div>
                <div class="input-dot" v-if="emailError"></div>
                <div class="input-msg" v-if="emailError">The email must be a valid email address.</div>
              </div>
              <div class="input-wrapper" :class="{ 'has-error': phoneError }">
                <div class="react-tel-input">
                  <div class="special-label">Phone</div>
                  <input 
                    type="tel" 
                    class="form-control input-phone" 
                    v-model="phone"
                    @blur="validatePhone"
                    @input="clearPhoneError"
                    placeholder="(702) 123-4567" 
                    name="phone" 
                    style="width: 100%;"
                  >
                  <div class="flag-dropdown">
                    <div class="selected-flag" title="United States: + 1" tabindex="-1" role="button" aria-haspopup="listbox">
                      <div class="flag us"></div>
                    </div>
                  </div>
                </div>
                <div class="input-dot" v-if="phoneError"></div>
                <div class="input-msg" v-if="phoneError">The phone number must be a valid phone number.</div>
              </div>
              <div class="input-wrapper" :class="{ 'has-error': passwordError }">
                <div class="form-group">
                  <div class="">
                    <input 
                      type="password" 
                      placeholder="Password (at least 6 characters)" 
                      v-model="password"
                      @blur="validatePassword"
                      @input="clearPasswordError"
                      class="form-control"
                      style="font-size: 18px;"
                    >
                  </div>
                </div>
                <div class="input-dot" v-if="passwordError"></div>
                <div class="input-msg" v-if="passwordError">The password must be at least 6 characters.</div>
              </div>
            </form>
            <div style="margin: 0px auto; width: 304px;">
              <div>
                <div style="width: 304px; height: 78px;">
                  <div class="recaptcha-placeholder">
                    <div class="recaptcha-box">
                      <input type="checkbox" v-model="recaptchaChecked" id="recaptcha-check">
                      <label for="recaptcha-check">I'm not a robot</label>
                      <div style="margin-left: auto; font-size: 10px; color: #999;">reCAPTCHA</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <button 
              class="sc-daURTG qtvwz" 
              :disabled="!isFormValid || isSubmitting"
              @click="handleSignup"
              style="margin-top: 15px;"
            >
              {{ isSubmitting ? 'Creating Account...' : 'Continue' }}
            </button>
            <div class="x-terms-and-privacy">
              <span>By continuing you agree to the </span>
              <a href="#/service">Terms of Service</a>
              <span> and </span>
              <a href="#/policy">Privacy Policy</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import userStore from '../../store/user.js'
import { userApi } from '../../api/index.js'

export default {
  name: 'SignupModal',
  props: {
    prefillData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      password: '',
      recaptchaChecked: false,
      firstNameError: false,
      lastNameError: false,
      emailError: false,
      phoneError: false,
      passwordError: false,
      isSubmitting: false
    }
  },
  watch: {
    prefillData: {
      immediate: true,
      handler(newData) {
        if (newData) {
          this.firstName = newData.firstname || ''
          this.lastName = newData.lastname || ''
          this.email = newData.email || ''
        }
      }
    }
  },
  computed: {
    isFormValid() {
      return this.firstName && 
             this.lastName && 
             this.email && 
             this.phone && 
             this.password &&
             this.password.length >= 6 &&
             this.isValidEmail(this.email) &&
             this.recaptchaChecked
    }
  },
  methods: {
    isValidEmail(email) {
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      return re.test(email)
    },
    validateFirstName() {
      this.firstNameError = !this.firstName
    },
    validateLastName() {
      this.lastNameError = !this.lastName
    },
    validateEmail() {
      this.emailError = !this.email || !this.isValidEmail(this.email)
    },
    validatePhone() {
      this.phoneError = !this.phone
    },
    validatePassword() {
      this.passwordError = !this.password || this.password.length < 6
    },
    clearFirstNameError() {
      if (this.firstName) this.firstNameError = false
    },
    clearLastNameError() {
      if (this.lastName) this.lastNameError = false
    },
    clearEmailError() {
      if (this.email) this.emailError = false
    },
    clearPhoneError() {
      if (this.phone) this.phoneError = false
    },
    clearPasswordError() {
      if (this.password) this.passwordError = false
    },
    async handleSignup() {
      // 验证所有字段
      this.validateFirstName()
      this.validateLastName()
      this.validateEmail()
      this.validatePhone()
      this.validatePassword()

      if (!this.isFormValid || this.isSubmitting) {
        return
      }

      this.isSubmitting = true

      try {
        // 调用注册 API
        const formData = new FormData()
        formData.append('firstname', this.firstName)
        formData.append('lastname', this.lastName)
        formData.append('email', this.email)
        formData.append('phone', this.phone)
        formData.append('password', this.password)

        const response = await userApi.register(formData)

        if (response.code === 1) {
          // 注册成功，自动登录
          const loginFormData = new FormData()
          loginFormData.append('email', this.email)
          loginFormData.append('password', this.password)
          loginFormData.append('type', 1) // 1:买家

          const loginResponse = await userApi.login(loginFormData)
          
          if (loginResponse.code === 1) {
            userStore.login(loginResponse.data)
            this.$toast('Sign up successful! Welcome to Koio deal!', 3000)
            this.$emit('close')
          } else {
            this.$toast('Sign up successful, please log in')
            this.$emit('close')
          }
        } else {
          this.$toast(response.msg || 'Sign up failed, please try again', 3000)
        }
      } catch (error) {
        console.error('Registration error:', error)
        this.$toast('Sign up failed: ' + (error.message || 'Network error, please try again'), 3000)
      } finally {
        this.isSubmitting = false
      }
    },
    handleBackdropClick() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.input-wrapper.has-error .form-control {
  border-color: #dc3545;
}

.input-wrapper.has-error .input-dot {
  display: block;
}

.input-wrapper.has-error .input-msg {
  display: block;
}

.recaptcha-placeholder {
  border: 1px solid #d3d3d3;
  border-radius: 3px;
  background: #f9f9f9;
  padding: 10px;
}

.recaptcha-box {
  display: flex;
  align-items: center;
  gap: 10px;
}

.recaptcha-box input[type="checkbox"] {
  width: 24px;
  height: 24px;
  cursor: pointer;
}

.recaptcha-box label {
  margin: 0;
  cursor: pointer;
  font-size: 14px;
  user-select: none;
}

button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
